import { generateJwt } from '../jwtGenerator'
import { deviceId } from '@/api/apiConstants'

export const generateDeviceId = () => {
    const accoundsArray = []
    const firstIndex = 1000
    const lastIndex = 4499
    for (let index = firstIndex; index < lastIndex + 1; index++) {
        accoundsArray.push(index)
    }

    const randomIndex = Math.floor(Math.random() * (accoundsArray.length - 1))
    return accoundsArray[randomIndex]
}

const jwtRepository = () => {
    const epoch = Math.floor(Date.now() / 1000)
    const randomSerialId = deviceId
    const date = new Date()
    date.setDate(date.getDate() + 30)
    const exp = Math.floor(date.getTime() / 1000)

    const nbf = epoch
    const headers = {
        alg: 'HS256',
        kid: -3,
        typ: 'JWT',
    }

    const loginPayload = {
        deviceId: randomSerialId,
        exp,
        iat: nbf,
        iss: 'urn:ToyaAPI',
        macaddr: randomSerialId,
        nbf,
        sub: randomSerialId,
        widevineId: 'wv123',
    }

    const headersStringified = JSON.stringify(headers)
    const loginPayloadStringified = JSON.stringify(loginPayload)

    return generateJwt(headersStringified, loginPayloadStringified, exp)
}

export default jwtRepository
